module.exports = __webpack_public_path__ + "img/file-icon.00a3f135.svg";